import {
  type QuizQuestionPoints,
  type QuizQuestionPointsOption,
} from '@efdigital/ll-addon-data';
import { fn } from '@ember/helper';
import Component from '@glimmer/component';

import type { QuizQuestionScoringEditorComponentSignature } from '../../types/question-manager';
import { Category } from './shared/category.gts';

export class PointsScoringEditorComponent extends Component<QuizQuestionScoringEditorComponentSignature> {
  get questionData(): QuizQuestionPoints {
    return this.args.question.points!;
  }

  setOptionCategory = (option: QuizQuestionPointsOption, category: string) => {
    option.category = category;
  };

  <template>
    <div class="card-body">
      <div class="form-label">For each option, the points allocated by the user
        will count toward the specified categories:</div>

      {{#each this.questionData.options as |option|}}
        <div class="mt-4">
          <Category
            @quiz={{@quiz}}
            @category={{option.category}}
            @onChange={{fn this.setOptionCategory option}}
          >
            <:label as |id|>
              <label for={{id}} class="h5 mt-1 mb-2">{{option.value}}</label>
            </:label>
          </Category>
        </div>
      {{/each}}
    </div>
  </template>
}
